import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';

var tableId = 'tableGameBuildConfigurationSummary';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";
var FILTER_DELIM = '-delim-';

var COLUMN_INDEX = {
    GameCode: 0,
    Operation: 1,
    Currency: 4,
    GameVariant: 7
}

export interface IndexPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlPost: string;
    urlRemove: string;
    urlClear: string;
    defaultHashButton: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
    }
}

export class SummaryPage extends PageBase<IndexPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _selectedType: string;

    private _btnShowMd5: JQuery;
    private _btnShowSha1: JQuery;
    private _btnShowSha256: JQuery;
    private _filterGame: MultiSelectApi;
    private _filterOperation: MultiSelectApi;
    private _filterCurrency: MultiSelectApi;

    private _filterVariants: JQuery;
    private _filterDisabled: JQuery;
    private _filterTotal: JQuery;
    private _summaryFilter: string;

    private _form: JQuery;
    private _btnCancelSearch: JQuery;

    private _hashTypes = ["MD5", "SHA1", "SHA256"];

    constructor(options: IndexPageOptions) {
        super(options);
        this._selectedType = options.defaultHashButton;
        this._summaryFilter = "variant";
        this.drawCallback = this.drawCallback.bind(this);
        this.showMd5 = this.showMd5.bind(this);
        this.showSha1 = this.showSha1.bind(this);
        this.showSha256 = this.showSha256.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
        this.cancelSearch = this.cancelSearch.bind(this);
        this.preDrawCallback = this.preDrawCallback.bind(this);
        this.filterChangedVariants = this.filterChangedVariants.bind(this);
        this.filterDisabledConfigurations = this.filterDisabledConfigurations.bind(this);
        this.filterAllConfigurations = this.filterAllConfigurations.bind(this);
        this.displayHash = this.displayHash.bind(this);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'GameCode',
            ordering: false,
            autoWidth: true,
            pageLength: 100,
            lengthMenu: [[50, 100, 200, 500, 1000], [50, 100, 200, 500, 1000]],
            columns: [
                {
                    sortable: false,
                    data: "GameCode",
                    render: (data: any, type: any, rowData: any) => {
                        var color = rowData.GameVariant !== rowData.NewGameVariant
                            ? "font-red"
                            : "";
                        return `<span id='spnGameCode${rowData.Id}' class='${color}'>${data}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "CustomerOperationCode",
                    render: (data: any, type: any, rowData: any) => {
                        var color = rowData.GameVariant !== rowData.NewGameVariant
                            ? "font-red"
                            : "";
                        return `<span id='spnCustomerOperationCode${rowData.Id}' class='${color}'>${rowData.CustomerCode} | ${data}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "GameStatus",
                    render: (data: any, type: any, rowData: any) => {
                        var text = data === true ? options.localizer.StatusEnabled : options.localizer.StatusDisabled;
                        var css = data === true ? 'status-enabled' : 'status-disabled';
                        return `<span id='spnGameStatus${rowData.Id}' class='${css}'>${text}</span>`;
                    }
                },
                {
                    sortable: false,
                    width: "10%",
                    data: "SelectedModuleVersion",
                    render: (data: any, type: any, rowData: any) =>
                        (`<span class='buildVersion-format' id='spnSelectedModuleVersion${rowData.Id}'>${data}</span>`)
                },
                {
                    sortable: false,
                    width: "5%",
                    render: (data: any, type: any, rowData: any) => {
                        var md5 = "";
                        var sha1 = "";
                        var sha256 = "";
                        if (rowData.Hashes.hasOwnProperty("MD5")) {
                            md5 = rowData.Hashes['MD5'];
                        }
                        if (rowData.Hashes.hasOwnProperty("SHA1")) {
                            sha1 = rowData.Hashes['SHA1'];
                        }
                        if (rowData.Hashes.hasOwnProperty("SHA256")) {
                            sha256 = rowData.Hashes['SHA256'];
                        }
                        return `<span id='spnSelectedModuleVersion$Md5Hash' name="md5hash" class="hash-format" title="${md5}">${this.shortHash(md5)}</span>
                          <span id='spnSelectedModuleVersion$Sha1Hash' name="sha1hash" class="hash-format" title="${sha1}">${this.shortHash(sha1)}</span>
                          <span id='spnSelectedModuleVersion$Sha256Hash' name="sha256hash" class="hash-format" title="${sha256}">${this.shortHash(sha256)}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "CurrencyCode",
                    render: (data: any, type: any, rowData: any) => {
                        var color = rowData.GameVariant !== rowData.NewGameVariant
                            ? "font-red"
                            : "";
                        return `<span id='spnCurrency${rowData.Id}' class='${color}'>${data}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "GameConfigurationStatus",
                    render: (data: any, type: any, rowData: any) => {
                        var css = "";
                        if (data === "Enabled") {
                            css = 'status-enabled';
                        }
                        if (data === "Disabled") {
                            css = 'status-disabled';
                        }
                        return `<span id='spnConfigurationStatus${rowData.Id}' class='${css}'>${data}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "GameVariant",
                    render: (data: any, type: any, rowData: any) => {
                        var color = rowData.GameVariant !== rowData.NewGameVariant
                            ? "font-red"
                            : "";
                        return `<span id='spnGameVariant${rowData.Id}' class='${color}'>${data}</span>`;
                    }
                },
                {
                    sortable: false,
                    data: "NewGameVariant",
                    render: (data: any, type: any, rowData: any) => {
                        var color = rowData.GameVariant !== rowData.NewGameVariant
                            ? "font-red"
                            : "";
                        return `<span id='spnNewGameVariant${rowData.Id}' class='${color}'>${data}</span>`;
                    }
                }
            ],
            callbacks: {
                drawCallback: this.drawCallback,
                preDrawCallback: this.preDrawCallback
            }
        };
    }

    init(): void {
        this._form = Utils.getJQueryById("formGameBuilConfigurationSummary");
        this._btnCancelSearch = Utils.getJQueryById("btnCancelSearch");
        
        this._btnShowMd5 = Utils.getJQueryById("MD5button");
        this._btnShowMd5.on("click", this.showMd5);

        this._btnShowSha1 = Utils.getJQueryById("SHA1button");
        this._btnShowSha1.on("click", this.showSha1);

        this._btnShowSha256 = Utils.getJQueryById("SHA256button");
        this._btnShowSha256.on("click", this.showSha256);

        this._filterGame = new MultiSelectApi('filterGame');
        this._filterOperation = new MultiSelectApi('filterOperation');
        this._filterCurrency = new MultiSelectApi('filterCurrency');

        this._filterVariants = Utils.getJQueryById("filterVariantsChanged");
        this._filterVariants.on("click", this.filterChangedVariants);
        this._filterDisabled = Utils.getJQueryById("filterDisabledConfigurations");
        this._filterDisabled.on("click", this.filterDisabledConfigurations);
        this._filterTotal = Utils.getJQueryById("filterTotal");
        this._filterTotal.on("click", this.filterAllConfigurations);

        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
        // == attach to events
        // filter form submit -> redraw table
        this._form.on('submit', this.formSubmit);

        // cancel search click -> reset filter row values
        this._btnCancelSearch.on('click', this.cancelSearch);
    }    

    private cancelSearch(e: JQueryEventObject): void {
        this._filterGame.selectAll();
        this._filterOperation.selectAll();
        this._filterCurrency.selectAll();
        this._summaryFilter = "variant";
    }

    private formSubmit(e: JQueryEventObject): any {
        e.preventDefault();
        this._table.draw();
        return false;
    }

    private filterChangedVariants() {
        this._summaryFilter = "variant";
        this._table.draw();
    }

    private filterDisabledConfigurations() {
        this._summaryFilter = "disabled";
        this._table.draw();
    }

    private filterAllConfigurations() {
        this._summaryFilter = "total";
        this._table.draw();
    }

    private showMd5(): void {
        this._selectedType = "MD5";
        this.displayHash();
    }

    private showSha1(): void {
        this._selectedType = "SHA1";
        this.displayHash();
    }

    private showSha256(): void {
        this._selectedType = "SHA256";
        this.displayHash();
    }

    private displayHash(): void {
        this._hashTypes.forEach(type => {
            $(`span[name='${type.toLowerCase()}hash']`).toggle(this._selectedType === type);
            $(`#${type}button`).toggleClass("green", this._selectedType === type);
        });
    }

    private drawCallback(datatable: DatatableApi): any {
        this.displayHash();
        if (this._summaryFilter === "variant") {
            $("#lblTotalConfigurations").removeClass("bg-info");
            $("#lblDisabledConfigurations").removeClass("bg-info");
            $("#lblVariantsChanged").addClass("bg-info");
        }
        if (this._summaryFilter === "disabled") {
            $("#lblTotalConfigurations").removeClass("bg-info");
            $("#lblDisabledConfigurations").addClass("bg-info");
            $("#lblVariantsChanged").removeClass("bg-info");
        }
        if (this._summaryFilter === "total") {
            $("#lblTotalConfigurations").addClass("bg-info");
            $("#lblDisabledConfigurations").removeClass("bg-info");
            $("#lblVariantsChanged").removeClass("bg-info");
        }
    }

    private preDrawCallback(datatable: DatatableApi): any {
        var filterGame = this._filterGame.isAllSelected() ? '' : this._filterGame.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.GameCode).search(filterGame);

        var filterCustomerOperation = this._filterOperation.isAllSelected() ? '' : this._filterOperation.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.Operation).search(filterCustomerOperation);

        var filterCurrency = this._filterCurrency.isAllSelected()? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
        datatable.columns(COLUMN_INDEX.Currency).search(filterCurrency);

        datatable.columns(COLUMN_INDEX.GameVariant).search(this._summaryFilter);

        return true;
    }

    private shortHash(hash : string): string {
        if (hash.length > 0) {
            return `${hash.substring(0, 4)}...${hash.substring(hash.length - 4)}`;
        }
        return "";
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GameBuildConfiguration/SummaryPage.ts
 **/